<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    userLoaded: function () {
      console.log("I am listening to the user loaded event in vuex-oidc");
    },

    reload() {
      this.isRouterAlive = false;
      console.log("reload");
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  mounted() {
    window.addEventListener("vuexoidc:userLoaded", this.userLoaded);
  },
  destroyed() {
    window.removeEventListener("vuexoidc:userLoaded", this.userLoaded);
  },
};
</script>
<style lang="css">
.el-tooltip__popper {
  max-width: 400px;
  line-height: 25px;
  font-size: 14px;
}
.own-el-select .el-input {
  width: 100% !important;
}
.question-content img {
  height: 100px !important;
}
.app-main table {
  user-select: text;
}
</style>


// WEBPACK FOOTER //
// src/App.vue